import { RELOAD_COMPONENT_TOPIC } from '../../../constants';
import { CrFilter } from '../../../customer-review-star-filter/types';
import { SortParameter } from '../../types';
import { fetchReviewListHtml } from './fetch-review-list-html';

export const reloadReviewList = async (rootElement: HTMLElement, filter?: CrFilter, sort?: SortParameter, page?: number) => {
    const offerIdDataAttribute = rootElement.getAttribute('data-offer-id');
    const productIdDataAttribute = rootElement.getAttribute('data-product-id');
    const offerIdOrProductId = offerIdDataAttribute || productIdDataAttribute;
    if (offerIdOrProductId == null) return;
    const existingReviewListNode = rootElement.querySelector('.js_pdp_cr-list');
    if (!existingReviewListNode) return;
    existingReviewListNode.outerHTML = await fetchReviewListHtml(offerIdOrProductId, filter, sort, page);
    o_global.eventQBus.emit(RELOAD_COMPONENT_TOPIC);
};
